"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const globals_1 = require("../../infra/globals");
const utils_1 = require("../../infra/utils");
class UiTable extends HTMLElement {
    title;
    data = [];
    startAfter = 0;
    constructor(title) {
        super();
        this.title = title;
    }
    async connectedCallback() {
        this.prepareTable();
        this.toggleLoader();
        await this.getData();
        this.toggleLoader();
        if (this.data.length > 0) {
            this.setLegend();
            this.setCaption();
            this.setCards();
            this.setPagination();
        }
    }
    get lastVisible() {
        return this._lastVisible ? this._lastVisible : {};
    }
    resetLastVisible = (docs) => {
        this._lastVisible = docs[docs.length - 1];
    };
    firestoreQuery = async (q) => {
        const snaps = await (0, firestore_1.getDocs)(q);
        this.resetLastVisible(snaps.docs);
        const docsWithRef = (0, utils_1.mapDocsWithFirebaseRef)(snaps.docs);
        this.data.push(...docsWithRef);
    };
    downloading = false;
    toggleLoader = () => {
        this.downloading = !this.downloading;
        const loaderDiv = this.querySelector(".loader-container");
        if (this.downloading)
            setTimeout(() => {
                loaderDiv.style.display = this.downloading ? "flex" : "none";
            }, 500);
        else
            loaderDiv.style.display = "none";
    };
    setCaption = () => {
        const captionDiv = this.querySelector("#caption");
        captionDiv.innerHTML = this.caption;
    };
    setLegend = () => {
        const legendDiv = this.querySelector("#legend");
        legendDiv.innerHTML = this.legend;
    };
    prepareTable = () => {
        this.innerHTML += `
      <div id="caption"></div>

      <div id="legend"></div>

      <div id="cards"></div>

      <div class="loader-container">
        <span class="loader"></span>
      </div>

      <div class="pagination"></div>
    `;
    };
    setPagination = () => {
        const paginationDiv = this.querySelector(".pagination");
        paginationDiv.innerHTML += `
      <button class="next-page">+</button>
    `;
        const nextPageButton = this.querySelector("button.next-page");
        nextPageButton.onclick = async (evt) => {
            evt.preventDefault();
            this.startAfter += globals_1.queryLimit;
            this.toggleLoader();
            await this.getData();
            this.toggleLoader();
            this.setCards();
        };
    };
}
exports.default = UiTable;
//# sourceMappingURL=data:application/json;base64,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